export default __webpack_public_path__ + "static/logo-ef317d79a9bb7afc8967d4fc84321955.svg";